exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RideShareNotificationModal_message_1olRK a {\n  color: #4a90e2;\n}\n", ""]);

// exports
exports.locals = {
	"message": "RideShareNotificationModal_message_1olRK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/RideShareNotificationModal/RideShareNotificationModal.css
// module id = 1261
// module chunks = 2